import 'whatwg-fetch'
import { services, externalServices } from '../config/services'
import errors from '../config/errors'
import { parseStringToBoolean } from './global'
import {
  CANADA_POST_ADDRESS_COMPLETE,
  CANADA_POST_API_KEY,
  CANADA_POST_RETRIEVE_ADDRESS,
  CYBER_SOURCE_HOST_ENV_VAR,
  ENABLE_AUTO_COMPLETE,
  SERVICE_HOST_ENV_VAR,
} from '../containers/constants'

export const webRequest = serviceUrl => {
  let url = serviceUrl
  if (url === undefined || typeof url !== 'string') {
    return new Error('Missing or incorrect url parameter.')
  }
  if (url.includes('http')) {
    return url
  }
  if (SERVICE_HOST_ENV_VAR in process.env) {
    const serviceHost = process.env[SERVICE_HOST_ENV_VAR].trim()
    url = `${serviceHost}${url}`
  }
  return url
}

export const getRequestConfig = serviceId => {
  if (!serviceId) {
    return Error('Service ID is missing.')
  }

  if (typeof serviceId !== 'string') {
    return Error('Service ID needs to be a string.')
  }

  if (!(serviceId in services)) {
    if (!(serviceId in externalServices)) {
      return Error(`The service ID "${serviceId}" was not found in services config.`)
    }
    return externalServices[serviceId]
  }

  return services[serviceId]
}

export const getErrorConfig = code => {
  if (!code) {
    return Error('Code is missing.')
  }

  if (!(code in errors)) {
    return Error(`The code "${code}" was not found in errors config.`)
  }

  return { ...errors[code] }
}

export const getCyberSourceConfig = () => {
  if (CYBER_SOURCE_HOST_ENV_VAR in process.env) {
    return process.env[CYBER_SOURCE_HOST_ENV_VAR].trim()
  }
  return externalServices.processPayment
}

export const getCanadaPostConfig = () => {
  if (
    CANADA_POST_ADDRESS_COMPLETE in process.env &&
    CANADA_POST_RETRIEVE_ADDRESS in process.env &&
    CANADA_POST_API_KEY in process.env
  ) {
    return {
      addressComplete: `${process.env[
        CANADA_POST_ADDRESS_COMPLETE
      ].trim()}?key=${process.env[CANADA_POST_API_KEY].trim()}`,
      retrieveAddress: `${process.env[
        CANADA_POST_RETRIEVE_ADDRESS
      ].trim()}?key=${process.env[CANADA_POST_API_KEY].trim()}`,
    }
  }
  return {
    addressComplete: `${externalServices.canadaPost.addressComplete}?key=${
      externalServices.canadaPost.key
    }`,
    retrieveAddress: `${externalServices.canadaPost.retrieveAddress}?key=${
      externalServices.canadaPost.key
    }`,
  }
}

export const isAutoCompleteEnabled = () => {
  if (ENABLE_AUTO_COMPLETE in process.env) {
    return parseStringToBoolean(process.env[ENABLE_AUTO_COMPLETE])
  }
  return externalServices.canadaPost.isAutoCompleteEnabled
}



// WEBPACK FOOTER //
// ./src/utils/requests.js